import { render, staticRenderFns } from "./Liff.vue?vue&type=template&id=e3799470&scoped=true&lang=pug&"
import script from "./Liff.vue?vue&type=script&lang=js&"
export * from "./Liff.vue?vue&type=script&lang=js&"
import style0 from "./Liff.vue?vue&type=style&index=0&id=e3799470&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3799470",
  null
  
)

export default component.exports